/* ==========================================================================
   PMP — Correctifs Clarity — 2026-09-01
   Base : audit Clarity du 29-30/08/2026.

   1. TUNNEL ARTICLE -> PRODUIT
      148 sessions ont lu un article, 0 n'a atteint une page produit dans la
      meme session. Scroll moyen 33,9 % : les CTA de bas d'article ne sont
      jamais vus. On ajoute un encart produit apres le 1er H2 + une barre
      collante mobile.
   2. CLICS MORTS
      - Lignes de tableau comparatif (5 clics en 1 s puis sortie, /de-de).
      - Bloc note/avis en tete de fiche produit (session /es-mx, trafic Ads).
      - Estimated total au panier (/en-gb/cart).
      - Hassle-free returns clique 6 fois de suite.
   3. CLS : hauteurs reservees (voir pmp-clarity-fixes.css).

   Principe : purement additif, aucune reecriture du DOM existant, chaque
   bloc isole dans un try/catch. Si un selecteur ne correspond plus, la
   fonction concernee ne fait rien et le reste continue de tourner.

   Note d'implementation : l'affichage de la barre collante repose sur un
   IntersectionObserver et NON sur window.scrollY. Sur ce theme le scroll est
   porte par <html> et window.scrollY reste a 0, ce qui rendait toute logique
   basee sur scrollY inoperante.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Utilitaires --------------------------------------------- */

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  var path = window.location.pathname;
  var isArticle = /\/blogs\/[^\/]+\/[^\/]+/.test(path);
  var isCart = /\/cart\/?$/.test(path);
  var isProduct = /(?:^|\/)products\//.test(path);

  function safe(name, fn) {
    try { fn(); } catch (e) {
      if (window.console && console.debug) console.debug('[pmp-clarity-fixes] ' + name + ':', e);
    }
  }

  /* Prix formate dans la devise du marche actif (Intl gere les 31 locales). */
  function money(cents) {
    if (typeof cents !== 'number') return '';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- Libelles -------------------------------------------------
     Renseignes depuis Liquid par snippets/pmp-clarity-fixes.liquid ;
     valeurs anglaises par defaut si l'objet n'est pas fourni. */
  var I18N = window.PMP_CF_I18N || {};
  I18N.shop = I18N.shop || 'Shop now';
  I18N.freeShipping = I18N.freeShipping || 'Free shipping';
  I18N.close = I18N.close || 'Close';
  I18N.seeReviews = I18N.seeReviews || 'Read the reviews';
  I18N.returnsDetail = I18N.returnsDetail || 'Free shipping on every order. 30-day money-back guarantee.';
  I18N.totalDetail = I18N.totalDetail || 'Shipping is free on every order. Taxes and duties are calculated at checkout.';

  /* ---------- Choix du produit a mettre en avant ------------------------ */

  /* Priorite 1 : le produit le plus lie dans l'article lui-meme. C'est le
     signal le plus fiable, il vient de la redaction. */
  function handleFromArticleLinks(scope) {
    var links = scope.querySelectorAll('a[href*="/products/"]');
    var counts = {};
    var best = null;
    var bestN = 0;
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      var m = href.match(/\/products\/([a-z0-9\-]+)/i);
      if (!m) continue;
      var h = m[1];
      counts[h] = (counts[h] || 0) + 1;
      if (counts[h] > bestN) { bestN = counts[h]; best = h; }
    }
    return best;
  }

  /* Priorite 2 : mots-cles sur le titre + l'URL, multilingue.
     Ordre volontairement du plus specifique au plus generique. */
  var KEYWORD_MAP = [
    [/collag|kollagen|colag/i, 'liquid-collagen-for-dogs'],
    [/yeast|hefepilz|malassezia|candida|levadura|levedura|lievito|levure/i, 'dog-yeast-infection-treatment'],
    [/melatonin|melatonina|melatonine/i, 'melatonin-for-dogs'],
    [/cranberr|arandano|oxicoco|mirtillo|canneberge/i, 'dog-cranberry-bladder-supplement'],
    [/dental|tartar|teeth|zahn|dientes|dentes|denti|dentaire/i, 'dog-dental-powder'],
    [/probiotic|probiotik|probiotico|probiotique/i, 'liquid-probiotic-for-dogs'],
    [/glucosamin|glucosamina/i, 'liquid-glucosamine-for-dogs'],
    [/ear\b|otitis|ohren|oido|orelha|orecchi|oreille/i, 'dog-ear-cleaner'],
    [/eye|tear.stain|vision|augen|ojo|olho|occhi|yeux/i, 'dog-eye-drops'],
    [/cough|respirator|husten|tos\b|tosse|toux/i, 'dog-cough-respiratory-drops'],
    [/itch|allerg|juck|picor|coceira|prurito|demangeais/i, 'dog-itchy-skin-supplement'],
    [/joint|hip\b|mobilit|gelenk|articula|articolaz/i, 'dog-hip-and-joint-chews'],
    [/immune|antibiot|immun|inmun|imun/i, 'dog-immune-support-drops']
  ];

  function handleFromKeywords() {
    var hay = (document.title || '') + ' ' + path;
    for (var i = 0; i < KEYWORD_MAP.length; i++) {
      if (KEYWORD_MAP[i][0].test(hay)) return KEYWORD_MAP[i][1];
    }
    return 'liquid-collagen-for-dogs'; /* produit phare par defaut */
  }

  var productCache = null;
  function fetchProduct(handle) {
    if (productCache) return productCache;
    productCache = fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productCache;
  }

  /* ---------- 1a. Encart produit apres le premier H2 -------------------- */

  function injectInlineCard(scope, product, url) {
    if (document.querySelector('.pmp-cf-card')) return null;
    var h2 = scope.querySelector('h2');
    if (!h2) return null;

    var card = document.createElement('a');
    card.className = 'pmp-cf-card';
    card.href = url;
    card.setAttribute('data-pmp-cf', 'inline-card');

    var img = (product && product.featured_image) ? product.featured_image : '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    var thumb = img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
    var imgTag = thumb
      ? '<img src="' + escapeHtml(thumb) + '" alt="" width="96" height="96" loading="lazy" decoding="async">'
      : '';

    var price = product ? money(product.price) : '';

    card.innerHTML =
      '<span class="pmp-cf-card__media">' + imgTag + '</span>' +
      '<span class="pmp-cf-card__body">' +
        '<span class="pmp-cf-card__eyebrow">Pure Majesty Pets</span>' +
        '<span class="pmp-cf-card__title">' + escapeHtml(product ? product.title : '') + '</span>' +
        '<span class="pmp-cf-card__meta">' +
          (price ? '<span class="pmp-cf-card__price">' + escapeHtml(price) + '</span>' : '') +
        '</span>' +
        '<span class="pmp-cf-card__cta">' + escapeHtml(I18N.shop) + '</span>' +
      '</span>';

    h2.parentNode.insertBefore(card, h2);
    return card;
  }

  /* ---------- 1b. Barre CTA collante (mobile) ---------------------------
     Declenchee par IntersectionObserver sur une sentinelle placee juste
     apres l'encart produit : la barre apparait des que l'offre sort de
     l'ecran. Independant du conteneur de scroll. */

  function injectStickyBar(scope, product, url, anchorNode) {
    if (document.querySelector('.pmp-cf-bar')) return;
    if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) return;
    try { if (sessionStorage.getItem('pmpCfBarClosed') === '1') return; } catch (e) {}

    var bar = document.createElement('div');
    bar.className = 'pmp-cf-bar';
    bar.setAttribute('data-visible', 'false');
    var price = product ? money(product.price) : '';

    bar.innerHTML =
      '<div class="pmp-cf-bar__body">' +
        '<div class="pmp-cf-bar__title">' + escapeHtml(product ? product.title : '') + '</div>' +
        '<div class="pmp-cf-bar__meta">' + (price ? escapeHtml(price) + ' · ' : '') + escapeHtml(I18N.freeShipping) + '</div>' +
      '</div>' +
      '<a class="pmp-cf-bar__cta" href="' + escapeHtml(url) + '">' + escapeHtml(I18N.shop) + '</a>' +
      '<button class="pmp-cf-bar__close" type="button" aria-label="' + escapeHtml(I18N.close) + '">×</button>';

    document.body.appendChild(bar);
    document.body.classList.add('pmp-cf-bar-on');

    bar.querySelector('.pmp-cf-bar__close').addEventListener('click', function () {
      bar.setAttribute('data-visible', 'false');
      document.body.classList.remove('pmp-cf-bar-on');
      try { sessionStorage.setItem('pmpCfBarClosed', '1'); } catch (e) {}
      setTimeout(function () { if (bar.parentNode) bar.parentNode.removeChild(bar); }, 300);
    });

    /* Sentinelle : juste apres l'encart produit, sinon apres le 1er H2. */
    var sentinel = document.createElement('span');
    sentinel.setAttribute('data-pmp-cf-sentinel', '1');
    sentinel.style.cssText = 'display:block;width:1px;height:1px;';
    var ref = anchorNode || scope.querySelector('h2');
    if (!ref || !ref.parentNode) return;
    ref.parentNode.insertBefore(sentinel, ref.nextSibling);

    if (!('IntersectionObserver' in window)) {
      bar.setAttribute('data-visible', 'true');
      return;
    }

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      /* Visible uniquement quand la sentinelle est passee au-dessus de
         l'ecran, c'est-a-dire quand le lecteur a depasse l'offre. */
      var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.setAttribute('data-visible', passed ? 'true' : 'false');
    }, { threshold: 0 }).observe(sentinel);
  }

  /* ---------- 1c. Lignes de tableau comparatif cliquables --------------- */

  function linkifyTableRows(scope, fallbackUrl) {
    var tables = scope.querySelectorAll('table');
    for (var t = 0; t < tables.length; t++) {
      var rows = tables[t].querySelectorAll('tr');
      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        if (!row.querySelector('td')) continue; /* ligne d'en-tete */
        if (row.hasAttribute('data-pmp-cf-row')) continue;

        var inner = row.querySelector('a[href]');
        var target = inner ? inner.getAttribute('href') : null;

        /* Sans lien dans la ligne, seule la ligne Pure Majesty devient
           cliquable, vers la fiche produit. On ne fabrique aucune
           destination pour les lignes concurrentes. */
        if (!target && /pure\s*majesty/i.test(row.textContent)) target = fallbackUrl;
        if (!target) continue;

        row.setAttribute('data-pmp-cf-row', '1');
        row.classList.add('pmp-cf-row-link');
        row.setAttribute('tabindex', '0');
        row.setAttribute('role', 'link');

        (function (destination, el) {
          function go(ev) {
            if (ev.target && ev.target.closest && ev.target.closest('a')) return;
            window.location.href = destination;
          }
          el.addEventListener('click', go);
          el.addEventListener('keydown', function (ev) {
            if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); go(ev); }
          });
        })(target, row);
      }
    }
  }

  /* ---------- 2a. Bloc note/avis cliquable (fiche produit) -------------- */

  function makeRatingClickable() {
    var target = document.querySelector('#AreviewsContainer, #az_reviews, .main_reviews_container');
    if (!target) return; /* pas de section avis : on n'ajoute aucun clic mort */

    var triggers = document.querySelectorAll(
      '.areviews_top_rating, .main_starts_box, .reviews_rating_title, ' +
      '.top_areviews_rating_counter, .AreviewsTotalNumber, .areviews_reviews_number, ' +
      '.rating, .rating-count, .rating-text'
    );

    for (var i = 0; i < triggers.length; i++) {
      var el = triggers[i];
      if (el.hasAttribute('data-pmp-cf-rating')) continue;
      if (el.closest('a, button')) continue; /* deja actionnable */
      el.setAttribute('data-pmp-cf-rating', '1');
      el.classList.add('pmp-cf-clickable');
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'link');
      el.setAttribute('title', I18N.seeReviews);

      (function (node) {
        function go(ev) {
          ev.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        node.addEventListener('click', go);
        node.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') go(ev);
        });
      })(el);
    }
  }

  /* ---------- Depliage generique ---------------------------------------- */

  function attachDisclosure(trigger, panelText, insertPanelAfter) {
    var panel = document.createElement('div');
    panel.className = 'pmp-cf-disclosure';
    panel.hidden = true;
    panel.textContent = panelText;
    if (insertPanelAfter && insertPanelAfter.parentNode) {
      insertPanelAfter.parentNode.insertBefore(panel, insertPanelAfter.nextSibling);
    } else {
      trigger.appendChild(panel);
    }

    var caret = document.createElement('span');
    caret.className = 'pmp-cf-caret';
    caret.textContent = '▼';
    trigger.appendChild(caret);

    trigger.classList.add('pmp-cf-clickable');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-expanded', 'false');

    function toggle(ev) {
      if (ev) ev.preventDefault();
      var open = panel.hidden;
      panel.hidden = !open;
      caret.setAttribute('data-open', open ? 'true' : 'false');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') toggle(ev);
    });
  }

  /* ---------- 2b. Hassle-free returns depliable ------------------------- */

  function makeReturnsExpandable() {
    var badge = document.getElementById('pmp-guarantee-badge');
    if (!badge || badge.hasAttribute('data-pmp-cf-returns')) return;
    var spans = badge.querySelectorAll('span');
    var trigger = null;
    for (var i = 0; i < spans.length; i++) {
      if (spans[i].children.length === 0 &&
          /return|retour|ruckgabe|devoluc|reso|retorno/i.test(spans[i].textContent)) {
        trigger = spans[i];
        break;
      }
    }
    if (!trigger) return;
    badge.setAttribute('data-pmp-cf-returns', '1');
    attachDisclosure(trigger, I18N.returnsDetail, badge.firstElementChild);
  }

  /* ---------- 2c. Estimated total depliable au panier ------------------- */

  function makeCartTotalExpandable() {
    if (document.querySelector('[data-pmp-cf-total]')) return;
    var nodes = document.querySelectorAll('.totals__total, .cart-summary__total, .totals, [class*="total"]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var txt = (node.textContent || '').trim();
      if (!txt || txt.length > 120) continue;
      if (!/estimated total|total estim|geschätzt|geschatzt|total previsto|totale stimato/i.test(txt)) continue;
      node.setAttribute('data-pmp-cf-total', '1');
      attachDisclosure(node, I18N.totalDetail, node);
      return;
    }
  }

  /* ---------- Orchestration -------------------------------------------- */

  function runArticle() {
    var scope = document.querySelector('.blog-post-content') || document.querySelector('article');
    if (!scope) return;

    var handle = handleFromArticleLinks(scope) || handleFromKeywords();
    var url = root + 'products/' + handle;

    safe('linkifyTableRows', function () { linkifyTableRows(scope, url); });

    fetchProduct(handle).then(function (product) {
      if (!product) return;
      var card = null;
      safe('injectInlineCard', function () { card = injectInlineCard(scope, product, url); });
      safe('injectStickyBar', function () { injectStickyBar(scope, product, url, card); });
    });
  }

  function runProduct() {
    safe('makeRatingClickable', makeRatingClickable);
    safe('makeReturnsExpandable', makeReturnsExpandable);
  }

  function runCart() {
    safe('makeCartTotalExpandable', makeCartTotalExpandable);
  }

  function init() {
    if (isArticle) safe('runArticle', runArticle);
    if (isProduct) safe('runProduct', runProduct);
    if (isCart) safe('runCart', runCart);

    /* Avis, badge garantie et panier sont injectes de facon asynchrone par
       des apps : on repasse quand le DOM bouge, observer borne dans le temps. */
    if (!window.MutationObserver) return;
    if (!isProduct && !isCart) return;
    var observer = new MutationObserver(function () {
      if (isProduct) runProduct();
      if (isCart) runCart();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
